import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryVisitChecklist: BlogMetaData = {
  title: '保育園見学チェックリスト20項目｜当日その場で見る・確認するポイント',
  description:
    '保育園見学で後悔しないための20項目チェックリスト。安全・先生の関わり・給食・料金・無償化など、当日その場で見る・確認するポイントを○△×で採点しながら整理。保護者タイプ別の重点ポイントとモンテッソーリ園の見極め基準も解説します。',
  thumbnailUrl: '/img/blog-nursery-visit-checklist.webp',
  filePath: buildBlogFilePath('nursery-visit-checklist'),
  category: BLOG_CATEGORY.NURSERY,
};
